import React from 'react';
import { Icon } from './Icon.js';
export const IconRectCenterYFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("rect", { x: "3", y: "3", width: "6", height: "6", rx: "1.75", ry: "1.75", strokeWidth: "0", fill: "currentColor" }),
        React.createElement("path", { d: "m11,1.5H1c-.414,0-.75-.336-.75-.75s.336-.75.75-.75h10c.414,0,.75.336.75.75s-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" }),
        React.createElement("path", { d: "m11,12H1c-.414,0-.75-.336-.75-.75s.336-.75.75-.75h10c.414,0,.75.336.75.75s-.336.75-.75.75Z", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconRectCenterYFill12.js.map